import { Component, Input, OnInit } from '@angular/core';
import { SocialMediaMetadataLego } from '../../shared/dto/social-media-metadata.lego';

@Component({
  selector: 'wl-social-media-lego-summary',
  templateUrl: './social-media-lego-summary.component.html',
  styleUrls: ['./social-media-lego-summary.component.less'],
    standalone: false
})
export class SocialMediaLegoSummaryComponent implements OnInit {
  @Input() socialMediaData: SocialMediaMetadataLego;

  constructor() {}

  ngOnInit(): void {}
}
